const DEFAULT = 2

const numberRound = (num, precision = DEFAULT) => {
  return num ? Number(Math.round(num + `e+${precision}`) + `e-${precision}`) : num
}

export default numberRound
